module.exports = __webpack_public_path__ + "static/Site-1-985cc46f13b39bf05763ea4c604a97d4.jpg";